import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 1rem;
  border-radius: 3px;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.16);
`;
export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Content = styled.div`
  padding-bottom: ${({ footer }) => (footer ? 0 : '33px')};
`;
export const Footer = styled.footer`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
